import { OnInit, Component } from '@angular/core';
import { FlatTreeControl } from '@angular/cdk/tree'
import { first } from 'rxjs/operators';
import { User, CategoryNode } from '../../_models';
import { AuthenticationService } from '../../_services/authentication.service';
import { CategoryService } from '../../_services/category.service';
import { UserService } from '../../_services/user.service'
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { MatTableDataSource } from '@angular/material/table';
import { MatDialog } from '@angular/material/dialog';
import { FormBuilder, Validators, FormArray, FormGroup } from '@angular/forms';
import { UsersAndGroupsService } from 'src/app/_services/users-and-groups.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { DialogDeleteConfirmComponent } from 'src/app/dialog-delete-confirm/dialog-delete-confirm.component';
import { AppConfig } from 'src/assets/config/config/app-config';
import { DialogPicklistComponent } from './dialog-picklist/dialog-picklist.component';
interface CategoryFlatNode {
  expandable: boolean;
  id: number;
  name: string;
  level: number;
  users: [];
}

@Component({
  selector: 'app-category-config',
  templateUrl: './category-config.component.html',
  styleUrls: ['./category-config.component.scss']
})
export class CategoryConfigComponent implements OnInit {
  searchCtrl: string = "";
  isAdmin: boolean = false;
  metaDataPropertyForm: FormGroup
  optionValueForm: FormGroup
  metaDataForm: FormGroup
  updateMetaDataForm: FormGroup
  currentUser: User;
  response: {};
  categories = [];
  category = {};
  toggleCheck: Boolean
  fetchedCatName: String;
  docResultsList: MatTableDataSource<any>;
  selectedCategoryNew: any = [];
  selectedCategory: Boolean = false;
  categoryId: String;
  categoryName: String;
  catname: string;
  metaDataProperties = [];
  metaData = [];
  usersList = [];
  addCategoryButton: Boolean = false;
  dropdownSettings = {};
  newMeta = [];
  newMetaDataProperties = [];
  updateCategoryProperties: any;
  fetchedParentId: number;
  addDocPerm: string[] = [];
  getDocPerm: string[] = [];
  compliancePerm: string[] = [];
  viewDocPerm: string[] = [];
  updateDocPerm: string[] = [];
  deleteDocPerm: string[] = [];
  createCatPerm: string[] = [];
  deleteCatPerm: string[] = [];
  updateCatPerm: string[] = [];
  getCatPerm: string[] = [];
  errorMsg = '';
  createdCategory: boolean = false;
  updatedCategory: boolean = false;
  navBarCategories
  filterValue
  userGroups: string[]
  isSubCategory: boolean = false
  isOptions: boolean = false
  sort;
  copiedGroups: string[]
  commonPermissions: string[]
  permissionsList: string[] = ["Add Document", "Update Document", "Delete Document", "View Document", "Get Document", "Create Category", "Get Category", "Update Category", "Delete Category", "Compliance"]
  permissionName: string
  cloneChild: boolean = false
  isDeletedCategory: boolean = false
  canDeleteCategory: boolean = false
  canAddSubCategory: boolean = false

  private _transformer = (node: CategoryNode, level: number) => {
    return {
      expandable: !!node.sub_categories && node.sub_categories.length > 0,
      id: node.id,
      name: node.name,
      level: level,
    };
  }

  treeControl = new FlatTreeControl<CategoryFlatNode>(
    node => node.level, node => node.expandable);

  treeFlattener = new MatTreeFlattener(
    this._transformer, node => node.level, node => node.expandable, node => node.sub_categories);

  categoryTreeData = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);


  constructor(
    private authenticationService: AuthenticationService,
    private categoryService: CategoryService,
    private userService: UserService,
    public dialog: MatDialog,
    private fb: FormBuilder,
    private usersGroupsService: UsersAndGroupsService,
    private config: AppConfig
  ) {
    this.currentUser = this.authenticationService.currentUserValue;
    this.userGroups = this.authenticationService.userGroupsValue;
    this.createNewCategoryForm();
    this.updateMetaDataForm = this.fb.group({
      Name: ['', Validators.required],
      updateCategoryProperties: this.fb.array([this.getcategoryProperties()]),
      Permissions: this.fb.group({
        add_document: ['', Validators.required],
        update_document: ['', Validators.required],
        view_document: ['', Validators.required],
        get_document: ['', Validators.required],
        delete_document: ['', Validators.required],
        create_category: ['', Validators.required],
        update_category: ['', Validators.required],
        get_category: ['', Validators.required],
        compliance: ['', Validators.required],
        delete_category: ['', Validators.required]
      })
    })
  }
  hasChild = (_: number, node: CategoryFlatNode) => node.expandable;

  ngOnInit(): void {
    this.filterValue = null
    this.categoryService.getCategoriesEdit().subscribe(categories => {
      this.categories = categories['results'];
      this.navBarCategories = categories['results']
      this.categoryTreeData.data = categories['results']
    })
    this.userService.getAll().pipe(first()).subscribe(usersList => { this.usersList = usersList; });
    this.getUpdateCategories();
    this.dropdownSettings = {
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
    }

    this.isAdmin = JSON.parse(localStorage.getItem("isAdmin"));

  }

  copyGroups(groups, permissionName) {
    this.copiedGroups = groups
    this.permissionName = permissionName
  }

  closeCopyGroups() {
    this.copiedGroups = null
  }

  cloneGroups() {
    this.commonPermissions.forEach(permission => {
      switch (permission) {
        case "Add Document":
          this.copiedGroups.forEach(group => {
            this.addDocPerm.push(group)
          })
          this.addDocPerm = this.addDocPerm.filter((elem, i, arr) => {
            if (arr.indexOf(elem) === i) {
              return elem
            }
          })
          break;
        case "Update Document":
          this.copiedGroups.forEach(group => {
            this.updateDocPerm.push(group)
          })
          this.updateDocPerm = this.updateDocPerm.filter((elem, i, arr) => {
            if (arr.indexOf(elem) === i) {
              return elem
            }
          })
          break;
        case "Delete Document":
          this.copiedGroups.forEach(group => {
            this.deleteDocPerm.push(group)
          })
          this.deleteDocPerm = this.deleteDocPerm.filter((elem, i, arr) => {
            if (arr.indexOf(elem) === i) {
              return elem
            }
          })
          break;
        case "View Document":
          this.copiedGroups.forEach(group => {
            this.viewDocPerm.push(group)
          })
          this.viewDocPerm = this.viewDocPerm.filter((elem, i, arr) => {
            if (arr.indexOf(elem) === i) {
              return elem
            }
          })
          break;
        case "Get Document":
          this.copiedGroups.forEach(group => {
            this.getDocPerm.push(group)
          })
          this.getDocPerm = this.getDocPerm.filter((elem, i, arr) => {
            if (arr.indexOf(elem) === i) {
              return elem
            }
          })
          break;
        case "Create Category":
          this.copiedGroups.forEach(group => {
            this.createCatPerm.push(group)
          })
          this.createCatPerm = this.createCatPerm.filter((elem, i, arr) => {
            if (arr.indexOf(elem) === i) {
              return elem
            }
          })
          break;
        case "Get Category":
          this.copiedGroups.forEach(group => {
            this.getCatPerm.push(group)
          })
          this.getCatPerm = this.getCatPerm.filter((elem, i, arr) => {
            if (arr.indexOf(elem) === i) {
              return elem
            }
          })
          break;
        case "Update Category":
          this.copiedGroups.forEach(group => {
            this.updateCatPerm.push(group)
          })
          this.updateCatPerm = this.updateCatPerm.filter((elem, i, arr) => {
            if (arr.indexOf(elem) === i) {
              return elem
            }
          })
          break;
        case "Delete Category":
          this.copiedGroups.forEach(group => {
            this.deleteCatPerm.push(group)
          })
          this.deleteCatPerm = this.deleteCatPerm.filter((elem, i, arr) => {
            if (arr.indexOf(elem) === i) {
              return elem
            }
          })
          break;
        case "Compliance":
          this.copiedGroups.forEach(group => {
            this.compliancePerm.push(group)
          })
          this.compliancePerm = this.compliancePerm.filter((elem, i, arr) => {
            if (arr.indexOf(elem) === i) {
              return elem
            }
          })
          break;
      }
    })
  }

  createNewCategoryForm() {
    this.metaDataForm = this.fb.group({
      Name: ['', Validators.required],
      categoryProperties: this.fb.array([this.getcategoryProperties()]),
      Permissions: this.fb.group({
        add_document: ['', Validators.required],
        update_document: ['', Validators.required],
        view_document: ['', Validators.required],
        get_document: ['', Validators.required],
        delete_document: ['', Validators.required],
        create_category: ['', Validators.required],
        update_category: ['', Validators.required],
        get_category: ['', Validators.required],
        compliance: ['', Validators.required],
        delete_category: ['', Validators.required]
      })
    })
  }

  applyFilter(event: Event) {
    this.filterValue = (event.target as HTMLInputElement).value;
    if (this.filterValue.length > 0) {
      this.navBarCategories = []
      this.search()
    }
    else {
      this.navBarCategories = this.categories
    }
  }

  search() {
    this.categories.filter(form => {
      if ((form.name.trim().toLowerCase().indexOf(this.filterValue.trim().toLowerCase()) > -1)) {
        this.navBarCategories.push(form)
      }
      if (form.sub_categories) {
        form.sub_categories.filter(element => {
          if ((element.name.trim().toLowerCase().indexOf(this.filterValue.trim().toLowerCase()) > -1)) {
            this.navBarCategories.push(form)
          }
        });
      }
      this.navBarCategories = this.navBarCategories.filter((elem, i, arr) => {
        if (arr.indexOf(elem) === i) {
          return elem
        }
      })
    }
    )
    this.categoryTreeData.data = this.navBarCategories
  }

  activateAddSubCategory() {
    this.reset()
    this.metaDataForm.reset()
    this.isSubCategory = true
    this.addCategoryButton = true;
    this.selectedCategory = true;
    this.cloneChild = false;
  }

  activateAddCategory(cloneCategory: boolean) {
    if (!cloneCategory) {
      this.metaDataForm.reset()
      this.reset()
    }
    this.isSubCategory = false
    this.addCategoryButton = true;
    this.selectedCategory = false;
  }

  private getUpdateCategories() { }

  private getCategoriesTree() {
    this.categoryService.getTree()
      .pipe(first())
      .subscribe(
        categories => {
          this.categories = categories;
          this.categoryTreeData.data = categories
        },
        error => { }
      );
  }

  cloneCategory(categoryDetails) {
    this.CategoryPropertiesArray.controls = this.UpdateCategoryPropertiesArray.controls
    if (categoryDetails.parent_id == 0) {
      this.cloneChild = false
    } else {
      this.cloneChild = true
      this.categoryId = categoryDetails.parent_id
    }
    this.activateAddCategory(true)
  }

  dropUpdate(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.UpdateCategoryPropertiesArray.controls, event.previousIndex, event.currentIndex);
    moveItemInArray(this.updateMetaDataForm.value.updateCategoryProperties, event.previousIndex, event.currentIndex);

  }

  dropCreate(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.CategoryPropertiesArray.controls, event.previousIndex, event.currentIndex);
    moveItemInArray(this.metaDataForm.value.categoryProperties, event.previousIndex, event.currentIndex);

  }

  selectCategory(name, id) {
    this.createdCategory = false
    this.updatedCategory = false
    this.selectedCategory = true;
    this.addCategoryButton = false;
    this.canDeleteCategory = false;
    this.canAddSubCategory = false;
    this.categoryId = id;
    this.categoryName = name;
    this.reset();
    this.categoryService.get(this.categoryId).subscribe(category => {
      this.category = category;
      this.metaDataProperties = this.category['meta_data_definition']['properties'];
      this.fetchedCatName = this.category['name'];
      this.setPermissions(this.category['permissions']);
      let deletePermissionGroups = this.category['permissions']['delete_category'];
      let createPermissionGroups = this.category['permissions']['create_category'];
      if(this.userGroups){
          for(let userGroup of this.userGroups){
          for(let deleteGroup of deletePermissionGroups){
            console.log(deleteGroup==userGroup)
            if(deleteGroup==userGroup){
              this.canDeleteCategory = true;
              break;
            }
          }
          for(let createGroup of createPermissionGroups){
            console.log(createGroup==userGroup)
            if(createGroup==userGroup){
              this.canAddSubCategory = true;
              break;
            }
          }
        }
      }
      this.fetchedParentId = this.category['parent_id']
      this.updateMetaDataForm.setControl('updateCategoryProperties', this.setExistingProperties(this.metaDataProperties));
    });
  }

  setPermissions(permissions) {
    this.addDocPerm = Object.assign([], permissions['add_document'])
    this.getDocPerm = Object.assign([], permissions['get_document']);
    this.compliancePerm = Object.assign([], permissions['compliance']);
    this.updateDocPerm = Object.assign([], permissions['update_document']);
    this.viewDocPerm = Object.assign([], permissions['view_document']);
    this.deleteDocPerm = Object.assign([], permissions['delete_document']);
    this.getCatPerm = Object.assign([], permissions['get_category']);
    this.createCatPerm = Object.assign([], permissions['create_category']);
    this.updateCatPerm = Object.assign([], permissions['update_category']);
    this.deleteCatPerm = Object.assign([], permissions['delete_category']);
  }

  setExistingProperties(propertiesSet: any[]): FormArray {
    const formArray = new FormArray([]);
    propertiesSet.forEach(p => {
      if (!p.values)
        p.values = []
      formArray.push(this.fb.group({
        name: [p.name, Validators.required],
        required: p.required,
        display_in_list: p.display_in_list,
        data_type: [p.data_type, Validators.required],
        values: [p.values]
      }));
    })
    return formArray;
  }

  permissions() {
    var perms = {
      "permissions": {
        "update_category": this.updateCatPerm,
        "get_category": this.getCatPerm,
        "create_category": this.createCatPerm,
        "delete_category": this.deleteCatPerm,
        "view_document": this.viewDocPerm,
        "add_document": this.addDocPerm,
        "update_document": this.updateDocPerm,
        "get_document": this.getDocPerm,
        "compliance": this.compliancePerm,
        "delete_document": this.deleteDocPerm
      }
    }
    return perms.permissions;
  }

  createNewCategory() {
    this.fetchedCatName = this.catname
    this.metaData = [
      {
        "properties": this.newMeta
      }
    ]

    var newCatReq = {
      "name": this.catname,
      "meta_data_definition": this.metaData,
      "permissions": this.permissions(),
      "parent_id": 0
    }

    this.categoryService.createCategory(newCatReq)
      .subscribe(resp => {
        this.createdCategory = true
        this.categoryId = resp;
        this.ngOnInit()
        this.reset()
      })
  }

  createNewSubCategory() {
    this.fetchedCatName = this.catname
    this.metaData = [
      {
        "properties": this.newMeta
      }
    ]
    var newSubCatReq = {
      "name": this.catname,
      "meta_data_definition": this.metaData,
      "permissions": this.permissions(),
      "parent_id": this.categoryId
    }
    this.categoryService.createCategory(newSubCatReq)
      .subscribe(resp => {
        this.createdCategory = true
        this.categoryId = resp;
        this.ngOnInit()
        this.reset()
      },
        error =>
          console.log("Error Message: " + error.error[0])
      )
  }


  reset() {
    this.createNewCategoryForm();
    this.addDocPerm = [];
    this.getDocPerm = [];
    this.compliancePerm = [];
    this.deleteDocPerm = [];
    this.viewDocPerm = [];
    this.getCatPerm = [];
    this.createCatPerm = [];
    this.deleteCatPerm = [];
    this.updateCatPerm = [];
    this.updateDocPerm = [];
    this.catname = null
    this.copiedGroups = null
  }

  setUpdateFormValue() {
    let control = <FormArray>this.updateMetaDataForm.controls.updateCategoryProperties;
    this.updateCategoryProperties.forEach(element => {
      control.push(this.fb.group({ name: element.name, required: element.required, data_type: element.data_type }))
    });

  }

  getCategory(event, categoryId) {
    this.selectedCategoryNew = this.categories.find(x => x.id == categoryId)
  }

  saveCatFormData(data) {
    this.newMeta = data['categoryProperties'];
    this.newMeta.forEach(element => {
      if (element.required == null) {
        element.required = false
      }
      if (element.display_in_list == null) {
        element.display_in_list = false
      }
    })
    return this.createNewCategory();
  }

  deleteMetaDataForm(index: number) {
    this.CategoryPropertiesArray.removeAt(index);
  }
  deleteOptionForm(index: number) {
    this.optionValueArray.removeAt(index);
  }
  applyFilterOnCategories(event: Event) {
    this.filterValue = (event.target as HTMLInputElement).value;
    if (this.filterValue.length > 0) {
      this.navBarCategories = []
      this.search()
    }
    else {
      this.categoryTreeData.data = this.categories
    }
  }

  deleteUpdateMetaDataForm(index: number) {
    this.UpdateCategoryPropertiesArray.removeAt(index);
  }

  saveSubCatFormData(data) {
    this.newMeta = data['categoryProperties'];
    this.newMeta.forEach(element => {
      if (element.data_type != "options") {
        delete element.values
      }
      if (element.required == null) {
        element.required = false
      }
      if (element.display_in_list == null) {
        element.display_in_list = false
      }
    })
    return this.createNewSubCategory();
  }

  saveUpdateCatFormData(data) {

    this.newMetaDataProperties = data['updateCategoryProperties']
    return this.updateCategory();
  }

  get CategoryPropertiesArray() {
    return <FormArray>this.metaDataForm.get("categoryProperties");
  }

  get optionValueArray() {
    return <FormArray>this.metaDataPropertyForm.get("value");
  }

  get UpdateCategoryPropertiesArray() {
    return <FormArray>this.updateMetaDataForm.get("updateCategoryProperties");
  }

  getcategoryProperties(): FormGroup {
    return this.metaDataPropertyForm = this.fb.group({
      name: ['', Validators.required],
      required: true,
      display_in_list: true,
      data_type: ['', Validators.required],
      values: [[]]
    })
  }

  optionProperties() {
    return this.optionValueForm = this.fb.group({
      value: ['']
    })
  }

  popupPicklistDialog(index, item) {
    let dialogRef = this.dialog.open(DialogPicklistComponent,
      { width: '50%', height: "80%", data: { selectedItem: item} });
        dialogRef.afterClosed().subscribe(result => {
          item = result;
      });
  }


  onChange(dataType) {
    if (dataType === "options") {
      this.isOptions = true
    }
    else {
      this.isOptions = false
    }
  }

  addNewUpdateProperty() {
    this.UpdateCategoryPropertiesArray.push(this.getcategoryProperties())
  }


  addNewProperty() {

    this.CategoryPropertiesArray.push(this.getcategoryProperties());
  }

  addNewValue() {
    this.optionValueArray.push(this.optionProperties())
  }
  removeProperty(index) {
    this.CategoryPropertiesArray.removeAt(index)
  }

  updateCategory() {
    this.newMetaDataProperties.forEach(property => {
      if (property.data_type != "options") {
        delete property.values
      }
    })
    var updateCatReq1 = {
      "Id": this.categoryId,
      "name": this.fetchedCatName,
      "meta_data_definition": {
        "properties": this.newMetaDataProperties
      },
      "permissions": this.permissions(),
      "parent_id": this.fetchedParentId,
    }

    var updateCatReq2 = {
      "Id": this.categoryId,
      "name": this.fetchedCatName,
      "permissions": this.permissions(),
      "parent_id": this.fetchedParentId,
    }
    if (JSON.stringify(this.newMetaDataProperties) === JSON.stringify(this.metaDataProperties)) {
      this.categoryService.updateCategory(updateCatReq2)
        .subscribe(resp => {
          this.response = resp;
          this.updatedCategory = true
          this.ngOnInit()
          this.categoryName = this.fetchedCatName
        },
          error =>
            console.log("Error Message: " + error),


        )
    }
    else {
      this.categoryService.updateCategory(updateCatReq1)
        .subscribe(resp => {
          this.updatedCategory = true
          this.response = resp;
          this.ngOnInit
          this.categoryName = this.fetchedCatName
        },
          error =>
            console.log("Error Message: " + error)
        )
    }
  }

  back() {
    this.updatedCategory = false;
    this.createdCategory = false;
  }

  refreshPage() {
    location.reload();
  }

  onCloseCreate() {
    this.addCategoryButton = false
    this.selectedCategory = false;
    this.isDeletedCategory = false;
    this.back();
  }

  deleteCategory(categoryID) {
    let dialogRef = this.dialog.open(DialogDeleteConfirmComponent,
      { width: '500px', data: { type: "Delete Category", payload: { Id: categoryID.toString() } } });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.ngOnInit()
        this.categoryName = this.fetchedCatName
        this.isDeletedCategory = true
      }
    })
  }

}